export default __webpack_public_path__ + "static/media/users.8a546dc3.svg";